import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import * as tus from "tus-js-client";
import { userSelector } from "../../store/selectors";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import "./ShareModal.css";
import SharePopup from "../VideoPage/SharePopup";
import ProjectSharePopup from "../../pages/ProjectScreen/ProjectSharePopup";

const ShareModal = ({
  isOpen = false,
  onClose = () => {},
  project,
  versionId = null,
  handleOpenBacklog,
  handleRenameProject,
  handleChangeCover,
  handleArchiveProject,
  handleDeleteProject,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(userSelector);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !isLoading
      ) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof onClose === "function") {
          onClose();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal} ref={modalRef}>
        <ProjectSharePopup
          isModal={true}
          onOpenBacklog={handleOpenBacklog}
          onChangeCover={handleChangeCover}
          onRename={handleRenameProject}
          onDelete={handleDeleteProject}
          onArchive={handleArchiveProject}
          project={project}
          versionId={versionId}
          className="project-share-popup-context-menu-relative"
        />
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 101,
    cursor: "default",
  },
  modal: {
    width: "610px",
    borderRadius: "16px",
    padding: "32px",
    position: "relative",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    scrollbarWidth: "none" /* Firefox */,
    msOverflowStyle: "none" /* IE and Edge */,
    "&::-webkit-scrollbar": {
      /* Chrome, Safari and Opera */ display: "none",
    },
  },
  contentContainer: {
    width: "100%",
    height: "500px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "32px",
  },
  title: {
    color: "#c1c4cb",
    fontSize: "24px",
    fontWeight: 600,
    fontFamily: "NT Somic",
    marginBottom: "32px",
    textAlign: "center",
  },
  tabContainer: {
    display: "flex",
    gap: "4px",
    marginBottom: "24px",
    justifyContent: "center",
    width: "400px",
  },
  tab: {
    padding: "8px 24px",
    borderRadius: "80px",
    border: "1px solid #333b4b",
    backgroundColor: "#1f242e",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    flex: 1,
    //maxWidth: "130px",
    whiteSpace: "nowrap",
    overflow: "visible",
  },
  activeTab: {
    backgroundColor: "#333b4b",
    color: "#e8f2ff",
  },
  input: {
    width: "400px",
    padding: "16px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    height: "56px",
    minHeight: "56px",
    maxHeight: "56px",
    lineHeight: "1.5",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  textarea: {
    width: "400px",
    height: "100px",
    padding: "16px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    boxSizing: "border-box",
  },
  uploadArea: {
    width: "400px",
    height: "70px",
    border: "1px dashed #333b4b",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "8px",
    boxSizing: "border-box",
  },
  uploadIcon: {
    width: "32px",
    height: "32px",
    background: `url(https://dashboard.codeparrot.ai/api/image/Z9q4RippvFKitUcs/icons-32-2.png)`,
    marginBottom: "8px",
  },
  uploadText: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
  },
  uploadLimit: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
  },
  submitButton: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    ":hover": {
      opacity: 0.9,
    },
    ":disabled": {
      opacity: 0.5,
      cursor: "default",
    },
  },
  submitButtonDisabled: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    opacity: 0.5,
    cursor: "default",
  },
  versionUploadArea: {
    width: "400px",
    height: "144px",
    border: "1px dashed #333b4b",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "16px",
    boxSizing: "border-box",
  },
  versionUploadIcon: {
    width: "32px",
    height: "32px",
    background: `url(https://dashboard.codeparrot.ai/api/image/Z9q4RippvFKitUcs/icons-32-2.png)`,
    marginBottom: "16px",
  },
  versionUploadText: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    textAlign: "center",
  },
  versionUploadSubtext: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "center",
    maxWidth: "400px",
  },
  versionLabel: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    marginTop: "8px",
  },
  loadingSpinner: {
    width: "32px",
    height: "32px",
    border: "3px solid #333b4b",
    borderTop: "3px solid #e8f2ff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "16px",
  },
  uploadProgress: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    marginTop: "8px",
  },
  versionThumbnail: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  },
};

export default ShareModal;
